import React from "react";

import Svg, { Path, G } from "components/Svg";

const ArrowUp = props => (
	<Svg
		width={25 * props.scale}
		height={15 * props.scale}
		viewBox="0 0 49.964 33.434"
	>
		<Path
			fill={props.fill || "white"}
			d="M21.331,1.7,1.214,25.43a4.845,4.845,0,0,0,3.683,8H45.131a4.845,4.845,0,0,0,3.683-8L28.768,1.7A4.917,4.917,0,0,0,21.331,1.7Z"
		/>
	</Svg>
);

export default ArrowUp;



// WEBPACK FOOTER //
// ./src/components/svgs/ArrowUp/index.js